import React, { Component } from 'react';
import Radium from 'radium';
import { number, string, bool, shape } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { UTCard } from '@widergy/energy-ui';

import Sidebar from 'app/components/Sidebar';
import Topbar from 'app/components/Topbar';
import UTUserForm from 'app/components/UTUserForm';
import { ROUTES } from 'constants/routes';
import { gaTrackPageView } from 'services/AnalyticsService';
import { accountPropTypes } from 'redux/accountHandlers';
import { appConfig } from 'config/customization';
import { isPublicSelector } from 'redux/auth/selector';

import { FORM_ID } from './constants';
import styles from './styles.module.scss';

class NewForm extends Component {
  state = { urlFormId: null };

  componentDidMount = () => {
    const redirectRoute = this.props.isPublic ? ROUTES.PUBLIC_PAYMENTS : ROUTES.ACCOUNT_STATUS;
    const parameters = new URLSearchParams(this.props.location.search);
    const urlFormId = parameters.get(FORM_ID);
    if (urlFormId) this.setState({ urlFormId });
    if (!(this.props.formId || urlFormId)) this.props.dispatch(push(redirectRoute));
    gaTrackPageView(this.props.location.pathname);
  };

  render() {
    const { isPublic, location, currentAccount } = this.props;
    const idForm = this.props.formId || this.state.urlFormId;
    return (
      <div className={styles.base}>
        <Topbar
          useClientSummary={currentAccount && appConfig.useClientSummary}
          clientSummary={!isPublic && location.pathname === ROUTES.CLIENT_SUMMARY}
        />
        <Sidebar location={this.props.location} />
        <div className={styles.content}>
          <UTCard className={styles.formContainer}>
            <UTUserForm formId={idForm} formType={this.props.formType} showTitle isPublic={isPublic} />
          </UTCard>
        </div>
      </div>
    );
  }
}

NewForm.propTypes = {
  formId: number,
  formType: string,
  location: shape({ pathname: string, search: string }),
  isPublic: bool,
  currentAccount: accountPropTypes
};

const mapStateToProps = store => ({
  formId: store.userForm.createForm.formId,
  formType: store.userForm.createForm.formType,
  currentAccount: store.account.currentAccount,
  isPublic: isPublicSelector(store)
});

export default connect(mapStateToProps)(Radium(NewForm));
